import { TableBody, TableCell, TableRow, Button } from "@windmill/react-ui";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import ViewModal from "components/modal/ViewDriverModal";
import VehicleAllotServices from "services/VehicleAllotServices";
import React, { useState, useContext } from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import { SidebarContext } from "context/SidebarContext";
import TripCompleted from "components/table/tripcompleted";
import { MdClose } from "react-icons/md";
import RemarkModal from "components/modal/RemarkModal";
import VehicleAllotDrawer from "components/drawer/VehicleAllotDrawer";
import Tooltip from "@mui/material/Tooltip";
import { getMonth } from "date-fns";
import { notifyError, notifySuccess } from "utils/toast";
// FontAwesome info icon
function formatHistoryDetails(driver) {
  if (!driver) return "No details available";
  const { driver_name, driver_contact_no } = driver;
  return `
Driver Name       : ${driver_name || "-"}
Contact Number    : ${driver_contact_no || "-"}
  `.trim();
}
function formatVehicleHistoryDetails(item) {
  let tripStatus = "Not chosen";
  if (item.trip_went_or_not === "1") {
    tripStatus = "Went for the trip";
  } else if (item.trip_went_or_not === "2") {
    tripStatus = "Did not go for the trip";
  }

  return `Vehicle Name: ${item.vehiclename || "-"}
Reg No: ${item.vehicle_reg_no || "-"}
Trip Went: ${tripStatus}`;
}

const VehicleAllotTable = ({
  dates,
  driver: allotments, // Renamed for clarity
  perpage,
  currentPage,
  tab,
  hideAdd,
  hideEdit,
  setIsUpdate,
}) => {
  const { isDrawerOpen } = useContext(SidebarContext);
  const { title, serviceBlock, serviceId } = useToggleDrawer();
  const { toggleDrawer } = useContext(SidebarContext);
  const [drivers, setDrivers] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [allotdata, setAllotdata] = useState();
  const [action, setAction] = useState("");
  const [clientArrived, setClientArrived] = useState(false);
  const [alreadyAssignedVehicle, setAlreadyAssignedVehicle] = useState([]);
  const [alreadyAssignedDriver, setAlreadyAssignedDriver] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedRemark, setSelectedRemark] = useState("");
  const [openUpdateTripStatusModal, setopenUpdateTripStatusModal] =
    useState(false);
  const [latestVaId, setLatestvaId] = useState();

  const handleOpen = (remark) => {
    setSelectedRemark(remark);
    setOpen(true);
  };
  const handleAllot = async (data) => {
    setAllotdata(data);
    try {
      const presentAllotment = data?.allotment_history?.find(
        (item) => item.status === "Present",
      );
      const response = await VehicleAllotServices.getVehicleDriverList({
        type: 3,
        vendor_id: data.vendor_id,
        va_start_date: presentAllotment?.va_start_date || "",
        va_end_date: presentAllotment?.va_end_date || "",
        vehicle_name_id: data.vehicle_type_client,
      });
      setDrivers(response?.can_allot_driver || []);
      setVehicles(response?.can_allot_vehicle || []);
      setAlreadyAssignedVehicle(response?.already_assigned_vehicle || []);
      setAlreadyAssignedDriver(response?.already_assigned_driver || []);
      // console.log(response)
    } catch (error) {
      console.error("Error fetching vehicle/driver list:", error);
    }
  };

  const handleClose = () => setOpen(false);
  const handleCloseConfirmModal = () => setopenUpdateTripStatusModal(false);
  const handleOpenConfirmModal = () => setopenUpdateTripStatusModal(true);
  // Ensure allotments is an array
  const allotmentList = Array.isArray(allotments) ? allotments : [];

  const currentDate = new Date()
    .toLocaleDateString("en-GB")
    .replace(/\//g, "-");
  const handleUpdateTripStatus = async () => {
    try {
      const response =
        await VehicleAllotServices.updateVehicleTripStatus(latestVaId);
      notifySuccess(response?.message);

      handleCloseConfirmModal();
      setIsUpdate(true); // Refetch parent data
    } catch (err) {
      console.error(err.response?.data);
      notifyError(err.response?.data?.message);
    }
  };

  return (
    <>
      <RemarkModal
        id_data={serviceId}
        block_data={serviceBlock}
        title_data={title}
      />
      <DeleteModal id={serviceId} title={title} />
      <ViewModal id={serviceId} title={title} data={allotments} />

      <MainDrawer>
        <VehicleAllotDrawer
          key={isDrawerOpen ? serviceId : "closed"}
          id={serviceId}
          assigned_driver={alreadyAssignedDriver}
          assigned_vehicle={alreadyAssignedVehicle}
          vehicles={vehicles}
          drivers={drivers}
          data={allotdata}
          tab={tab}
          action={action}
          isOpen={isDrawerOpen}
          clientArrived={clientArrived}
           package_type={allotdata?.package_type}
           days={allotdata?.no_of_days}
        />
      </MainDrawer>

      <TableBody>
        {allotmentList.length > 0 ? (
          allotmentList.slice(0, perpage).map((data, index) => (
            <TableRow
              key={data.ref_no || index}
              className={`${
                data.trip_completed === 1 || data.trip_completed === "1"
                  ? "bg-green-100"
                  : ""
              } ${data.status === 1 || data.status === "1" ? "bg-red-100" : ""} ${
                data.is_client_not_arrived === true && data.status === "1"
                  ? "bg-yellow-100"
                  : ""
              }`}
            >
              <TableCell className="font-semibold uppercase text-sm text-center">
                {(currentPage - 1) * perpage + index + 1}
                {/* {console.log(data)} */}
              </TableCell>
              <TableCell className="text-sm text-center">
                {data.ref_no}
              </TableCell>
              <TableCell className="text-sm text-center">
                {data.client_name}
              </TableCell>

              <TableCell className="text-center text-sm">
                <div className="flex flex-col gap-3">
                  <span className="text-sm mb-0 text-teal-500">
                    {data?.arrival_name}
                  </span>
                  <span className="text-sm text-yellow-700">
                    {data?.departure_name}
                  </span>
                </div>
              </TableCell>

              <TableCell className="text-sm text-center font-medium">
                <span>{data.start_date}</span>
                <br />
                <span>{data.end_date}</span>
              </TableCell>
              <TableCell className="text-center text-sm">
                {data.package_type}
              </TableCell>

              {tab == 0 && (
                <TableCell className="text-sm text-center font-medium">
                  <span>{data.client_vehiclename}</span>
                </TableCell>
              )}
              <TableCell className="text-sm text-center font-medium">
                {(data?.allotment_history || []).map((item, index) => (
                  <div
                    key={item.va_id || index}
                    className={`mb-1 ${
                      item.status === "Present" ? "text-black" : "text-red-600"
                    }`}
                  >
                    {item.franchise_name || "-"}
                  </div>
                ))}
              </TableCell>
              <TableCell className="text-sm text-center font-medium">
                {(data?.allotment_history || []).map((item, index) => (
                  <div
                    key={item.va_id || index}
                    className={`mb-1 ${
                      item.status === "Present" ? "text-black" : "text-red-600"
                    }`}
                  >
                    {item.vendor_name || "-"}
                  </div>
                ))}
              </TableCell>

              <TableCell className="text-sm text-center font-medium">
                {(data?.allotment_history || []).map((item, index) => (
                  <div
                    key={item.va_id || index}
                    className={`mb-1 ${
                      item.status === "Present" ? "text-black" : "text-red-600"
                    }`}
                  >
                    {item?.vehicle_name || "-"} {item?.vehicle_reg_no}
                  </div>
                ))}
              </TableCell>
              <TableCell className="text-sm">
                {(data?.allotment_history || []).map((item, index) => (
                  <div
                    key={item.va_id || index}
                    className={`mb-1 text-center ${
                      item.status === "Present" ? "text-black" : "text-red-600"
                    }`}
                  >
                    <Tooltip
                      title={item.driver_number || "No Driver Number"}
                      placement="top"
                      arrow
                    >
                      <span className="cursor-pointer">
                        {item.driver_name || "-"}
                      </span>
                    </Tooltip>
                  </div>
                ))}
              </TableCell>

              {/* <TableCell className="text-sm text-center font-medium">
                {(data?.allotment_history || []).map((item, index) => (
                  <div
                    key={item.va_id || index}
                    className={`mb-1 ${
                      item.status === "Present" ? "text-black" : "text-red-600"
                    }`}
                  >
                    {item.va_start_date || "-"} - {item.va_end_date || "-"}
                  </div>
                ))}
              </TableCell> */}

              {/* <TableCell className="text-sm text-center font-medium">
                {(data?.allotment_history || []).map((item, index) => (
                  <Tooltip
                    key={item.va_id || index}
                    title={item?.trip_status_text}
                    arrow
                    placement="top"
                  >
                    <div
                      className={`mb-1 cursor-pointer ${
                        item.status === "Present"
                          ? "text-black"
                          : "text-red-600"
                      }`}
                    >
                      {item.va_start_date || "-"} - {item.va_end_date || "-"}
                    </div>
                  </Tooltip>
                ))}
              </TableCell> */}

              <TableCell className="text-sm text-center font-medium">
                {(data?.allotment_history || []).map((item, index) => (
                  <div
                    key={item.va_id || index}
                    className={`mb-1 cursor-pointer ${
                      item.status === "Present" ? "text-black" : "text-red-600"
                    }`}
                  >
                    {item?.trip_status_text === "Not Went"
                      ? item.trip_status_text
                      : `${item.va_start_date || "-"} - ${item.va_end_date || "-"}`}
                  </div>
                ))}
              </TableCell>

              <TableCell className="text-sm text-center font-medium">
                {(data?.allotment_history || []).map((item, index) => (
                  <div key={item.va_id || index} className="mb-1">
                    {item.reason ? (
                      <span
                        className="text-blue-600 cursor-pointer"
                        onClick={() => handleOpen(item)}
                        onKeyDown={(e) => e.key === "Enter" && handleOpen(item)}
                        tabIndex={0}
                        role="button"
                      >
                        Remark
                      </span>
                    ) : (
                      <span>-</span>
                    )}
                  </div>
                ))}
              </TableCell>

              <TableCell className="text-center text-sm">
                <p
                  className={`px-2 py-1 mb-0 rounded-full text-sm font-semibold ${
                    data?.trip_status === "Upcoming"
                      ? "text-blue-700"
                      : data?.trip_status === "Ongoing"
                        ? " text-yellow-600"
                        : data?.trip_status === "Completed"
                          ? " text-green-700"
                          : data?.trip_status === "Cancelled"
                            ? " text-red-700"
                            : " text-gray-700"
                  }`}
                >
                  {data?.trip_status}
                </p>
                {hideEdit && data?.can_complete && (
                  <button
                    type="button"
                    className="bg-green-500 hover:bg-green-600 text-white px-3 py-2 rounded-md text-sm font-medium transition duration-200"
                    onClick={() => (
                      setLatestvaId(data?.latest_va_id),
                      handleOpenConfirmModal()
                    )}
                  >
                    Update Trip
                  </button>
                )}
              </TableCell>

              {/* {(tab === 1 || tab === 2) && (
                <TableCell align="center">
                  {currentDate === data?.end_date &&
                  data?.trip_status !== "Completed" &&
                  data?.trip_status !== "Upcoming" ? (
                    <button
                      type="button"
                      className="bg-green-500 hover:bg-green-600 text-white px-3 py-2 rounded-md text-sm font-medium transition duration-200"
                      onClick={() => (
                        setLatestvaId(data?.latest_va_id),
                        handleOpenConfirmModal()
                      )}
                    >
                      Update Trip
                    </button>
                  ) : (
                    <span>-</span>
                  )}
                </TableCell>
              )} */}

              {hideEdit && tab !== 3   && (
                <TableCell className="text-sm text-center font-medium">
                  {(() => {
                    const [day, month, year] = (data.end_date || "").split("-");
                    if (!day || !month || !year) return <span>-</span>;

                    const endDate = new Date(`${year}-${month}-${day}`);
                    const currentDate = new Date();
                    currentDate.setHours(0, 0, 0, 0);

                    const isFutureOrToday = currentDate <= endDate;

                    const vehicleHistory = Array.isArray(data.vehicle_history)
                      ? data.vehicle_history
                      : [];
                    const currentVehicleEntry = vehicleHistory.find(
                      (v) => v.type === "current",
                    );
                    const historyTripCompleted =
                      currentVehicleEntry?.trip_completed === 1 ||
                      currentVehicleEntry?.trip_completed === "1";

                    const isTripCompleted =
                      data.trip_completed === 1 ||
                      data.trip_completed === "1" ||
                      historyTripCompleted;
                    const isCancelled =
                      data.status === 1 || data.status === "1";
                    // const isClientNotArrived = data.is_client_not_arrived === true;

                    if (
                      (!isFutureOrToday && !data?.can_allot) ||
                      isTripCompleted ||
                      isCancelled
                    ) {
                      return <span>-</span>;
                    }

                    if (!hideEdit) return <span>-</span>;

                    // const allAreHistory =
                    //   vehicleHistory.length > 0 &&
                    //   vehicleHistory.every((item) => item.type === "history");

                    if (tab === 0) {
                      const showAllot = data?.can_allot;
                      return (
                        <div className="flex justify-center">
                          {showAllot ? (
                            <Button
                              onClick={() => {
                                setAction("allot");
                                toggleDrawer();
                                handleAllot(data);
                              }}
                              aria-label="Allot vehicle"
                            >
                              Allot
                            </Button>
                          ) : (
                            <span>-</span>
                          )}
                        </div>
                      );
                    }

                    if (tab === 1) {
                      // const showModify =
                      //   !allAreHistory && data.trip_status !== "Completed";
                      const showModify = data?.can_modify;
                      return (
                        <div className="flex justify-center">
                          {showModify ? (
                            <Button
                              onClick={() => {
                                toggleDrawer();
                                setAllotdata(data);
                                setAction("modify");
                                setClientArrived(data?.is_client_arrived);
                              }}
                              aria-label="Modify allotment"
                            >
                              Modify
                            </Button>
                          ) : (
                            <span>-</span>
                          )}
                        </div>
                      );
                    }

                    // if (tab === 2) {
                    //   const driverHistory = Array.isArray(data.driver_history)
                    //     ? data.driver_history
                    //     : [];
                    //   const currentDriver = driverHistory.find(
                    //     (d) => d.type === "current",
                    //   );

                    //   const isCurrentEmpty =
                    //     currentVehicleEntry?.vehiclename === null &&
                    //     currentDriver?.driver_name === null;

                    //   const showAllot =
                    //     (data.va_driver_id === 0 && data.va_vehicle_id === 0) ||
                    //     isCurrentEmpty;

                    //   return (
                    //     <div className="flex justify-center">
                    //       {showAllot ? (
                    //         <Button
                    //           onClick={() => {
                    //             toggleDrawer();
                    //             handleAllot(data);
                    //             setAction("allot");
                    //           }}
                    //           aria-label="Allot vehicle"
                    //         >
                    //           Allot
                    //         </Button>
                    //       ) : (
                    //         <Button
                    //           onClick={() => {
                    //             toggleDrawer();
                    //             setAllotdata(data);
                    //             setAction("modify");
                    //           }}
                    //           aria-label="Modify allotment"
                    //         >
                    //           Modify
                    //         </Button>
                    //       )}
                    //     </div>
                    //   );
                    // }

                    // if (tab === 2) {
                    //   const currentAllotment = (
                    //     data.allotment_history || []
                    //   ).find((item) => item.status === "Present");

                    //   const hasDriverOrVehicle =
                    //     currentAllotment &&
                    //     (currentAllotment.driver_name ||
                    //       currentAllotment.vehicle_name ||
                    //       currentAllotment.vehicle_reg_no);

                    //   const showAllot = !hasDriverOrVehicle;
                    //   const showModify =
                    //     hasDriverOrVehicle && data.trip_status !== "Completed";

                    //   return (
                    //     <div className="flex justify-center">
                    //       {showAllot && (
                    //         <Button
                    //           onClick={() => {
                    //             toggleDrawer();
                    //             handleAllot(data);
                    //             setAction("allot");
                    //           }}
                    //         >
                    //           Allot
                    //         </Button>
                    //       )}

                    //       {showModify && (
                    //         <Button
                    //           onClick={() => {
                    //             toggleDrawer();
                    //             handleAllot(data);
                    //             setAllotdata(data);
                    //             setAction("modify");
                    //           }}
                    //         >
                    //           Modify
                    //         </Button>
                    //       )}
                    //     </div>
                    //   );
                    // }

                    if (tab === 2) {
                      // const currentAllotment = (
                      //   data.allotment_history || []
                      // ).find((item) => item.status === "Present");

                      // const hasDriverOrVehicle =
                      //   currentAllotment &&
                      //   (currentAllotment.driver_name ||
                      //     currentAllotment.vehicle_name ||
                      //     currentAllotment.vehicle_reg_no);

                      // const showAllot = !hasDriverOrVehicle;
                      // const showModify =
                      //   hasDriverOrVehicle && data.trip_status !== "Completed";

                      const showAllot = data?.can_allot;
                      const showModify = data?.can_modify;

                      if (!showAllot && !showModify) {
                        return <span>-</span>;
                      }

                      return (
                        <div className="flex justify-center gap-2">
                          {showAllot && (
                            <Button
                              onClick={() => {
                                toggleDrawer();
                                handleAllot(data);
                                setAction("allot");
                                setClientArrived(data?.is_client_arrived);
                              }}
                            >
                              Allot
                            </Button>
                          )}

                          {showModify && (
                            <Button
                              onClick={() => {
                                toggleDrawer();
                                handleAllot(data);
                                setAllotdata(data);
                                setAction("modify");
                                setClientArrived(data?.is_client_arrived);
                              }}
                            >
                              Modify
                            </Button>
                          )}
                        </div>
                      );
                    }

                    return <span>-</span>;
                  })()}
                </TableCell>
              )}
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell
              colSpan={tab === 0 ? 7 : tab === 3 ? 8 : 9}
              className="text-center"
            >
              No data available
            </TableCell>
          </TableRow>
        )}
      </TableBody>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{ position: "absolute", top: 8, right: 8 }}
            aria-label="Close remark modal"
          >
            <MdClose size={24} />
          </IconButton>
          <Typography variant="body1" sx={{ mt: 4 }}>
            {/* <p className="text-sm font-medium"> Franchise Name: {selectedRemark?.franchise_name}</p>
            <p className="text-sm font-medium"> Vendor Name: {selectedRemark?.vendor_name}</p>
             <p className="text-sm font-medium"> Driver Name: {selectedRemark?.driver_name}</p>
              <p className="text-sm font-medium"> Vehicle Name: {selectedRemark?.vehicle_name}</p>
            <p className="text-sm font-medium"> Start Date: {selectedRemark?.va_start_date}</p>
            <p className="text-sm font-medium"> End Date: {selectedRemark?.va_end_date}</p> */}
            <p className="text-sm font-medium">
              {" "}
              Reason: {selectedRemark?.reason}
            </p>
          </Typography>
        </Box>
      </Modal>

      <Modal open={openUpdateTripStatusModal} onClose={handleCloseConfirmModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 350,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
            textAlign: "center",
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>
            Confirmation
          </Typography>

          <Typography variant="body1" sx={{ mb: 3 }}>
            Are you sure you want to update the trip status?
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 2,
            }}
          >
            <Button
              variant="outlined"
              color="inherit"
              onClick={handleCloseConfirmModal}
            >
              No
            </Button>

            <Button
              variant="contained"
              color="success"
              onClick={() => {
                handleUpdateTripStatus(); // Your API call
              }}
            >
              Yes
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default VehicleAllotTable;
